import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { withTheme } from 'common/styling/theme';
import { getDynamicStyles, staticStyles } from './style';

const CurrentIBProgramsItem = ({ conditions, theme }) => {
  // 状态管理 - 控制区块的展开/折叠
  const [expandedSections, setExpandedSections] = useState({
    symbolGroupExceptions: true,
    symbolExceptions: true,
    currentIBProgram: true,
  });

  // 状态管理 - 控制tooltip的显示
  const [showTooltip, setShowTooltip] = useState(false);

  // 切换区块的展开/折叠状态
  const toggleSection = sectionName => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  // 从conditions中解构所需的字段，并提供默认值以增强健壮性
  const {
    symbolExceptionsFormat,
    groupExceptionsFormat,
    baseForVolume,
    baseForSpread,
    baseForPercentage,
    subIbEnabled,
    subIbSettings,
    // eslint-disable-next-line camelcase
    table_type,
    pnlReward,
    netDepositReward,
  } = conditions || {};
  const programName = conditions?.program || '';

  // 映射reward_type到对应的显示文本
  const mapRewardTypeToText = rewardType => {
    const typeMap = {
      spread: 'Percentage for spread',
      fix: 'Fixed amount',
      percentage: 'Percentage for commissions',
    };
    return typeMap[rewardType] || rewardType || '';
  };

  return (
    <div className="CurrentIBProgramsItem">
      {programName && (
        <>
          <div className="currentIBProgram">
            <p className="program-name">
              <span>
                <strong>Program:</strong> {programName}
              </span>
              {/* eslint-disable-next-line camelcase */}
              {table_type === 'a_book_table' && (
                // eslint-disable-next-line camelcase
                <p className="program-limitation">
                  (This program is limited to <strong>A-Book</strong> clients for calculation.)
                </p>
              )}
              {/* eslint-disable-next-line camelcase */}
              {table_type === 'b_book_table' && (
                // eslint-disable-next-line camelcase
                <p className="program-limitation">
                  (This program is limited to <strong>B-Book</strong> clients for calculation.)
                </p>
              )}
            </p>
            <button
              type="button"
              className={`arrow-icon ${expandedSections.currentIBProgram ? 'expanded' : ''}`}
              onClick={() => toggleSection('currentIBProgram')}
              style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
              aria-expanded={expandedSections.currentIBProgram}
              aria-label={expandedSections.currentIBProgram ? '收起区块' : '展开区块'}>
              ›
            </button>
          </div>
        </>
      )}

      {expandedSections.currentIBProgram && (
        <>
          {/* Default Reward 区块 */}
          <div className="section">
            <div className="section-header">
              <h3 className="section-title">Default Reward</h3>
              {programName === 'Profit & Loss' && (
                <div
                  className="info-icon-container"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}>
                  <div className="info-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="10" cy="10" r="9.5" stroke="#2c008f" />
                      <path
                        d="M10.786 15H9.092V7.678H10.786V15ZM10.968 5.536C10.968 5.85333 10.8653 6.10533 10.66 6.292C10.4547 6.47867 10.212 6.572 9.932 6.572C9.64267 6.572 9.39533 6.47867 9.19 6.292C8.98467 6.10533 8.882 5.85333 8.882 5.536C8.882 5.20933 8.98467 4.95267 9.19 4.766C9.39533 4.57933 9.64267 4.486 9.932 4.486C10.212 4.486 10.4547 4.57933 10.66 4.766C10.8653 4.95267 10.968 5.20933 10.968 5.536Z"
                        fill="#2c008f"
                      />
                    </svg>
                  </div>
                  {showTooltip && (
                    <div className="tooltip">
                      If you lose, IB gets commission on loss × percentage. If you profit then lose, IB only gets
                      commission on losses beyond your profit.
                    </div>
                  )}
                </div>
              )}
              {programName === 'Net Deposit Sharing' && (
                <div
                  className="info-icon-container"
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}>
                  <div className="info-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="10" cy="10" r="9.5" stroke="#2c008f" />
                      <path
                        d="M10.786 15H9.092V7.678H10.786V15ZM10.968 5.536C10.968 5.85333 10.8653 6.10533 10.66 6.292C10.4547 6.47867 10.212 6.572 9.932 6.572C9.64267 6.572 9.39533 6.47867 9.19 6.292C8.98467 6.10533 8.882 5.85333 8.882 5.536C8.882 5.20933 8.98467 4.95267 9.19 4.766C9.39533 4.57933 9.64267 4.486 9.932 4.486C10.212 4.486 10.4547 4.57933 10.66 4.766C10.8653 4.95267 10.968 5.20933 10.968 5.536Z"
                        fill="#2c008f"
                      />
                    </svg>
                  </div>
                  {showTooltip && (
                    <div className="tooltip">
                      Your reward = (Current net deposits - Accumulated net withdrawals) x Percentage or fixed amount
                      range.
                    </div>
                  )}
                </div>
              )}
            </div>

            {programName === 'Traded Volume' && (
              <div className="rewards-card">
                <div className="rewards-header">
                  <span className="header-text">Base reward for volume</span>
                  <span className="header-text">Base reward for spread</span>
                  <span className="header-text">Base reward for commissions</span>
                </div>
                <div className="rewards-body">
                  <span className="reward-value">{baseForVolume ?? 0}USD</span>
                  <span className="reward-value">{baseForSpread ?? 0}%</span>
                  <span className="reward-value">{baseForPercentage ?? 0}%</span>
                </div>
              </div>
            )}

            {programName === 'Profit & Loss' && (
              <>
                {/* Percentage Reward Type */}
                {pnlReward?.reward_type === 'percentage' && (
                  <div className="rewards-card-pnl">
                    <div className="rewards-body-pnl">
                      <span className="reward-value-pnl">{pnlReward.value.value ?? 0}%</span>
                    </div>
                  </div>
                )}

                {/* Tiered Rebate Reward Type */}
                {pnlReward?.reward_type === 'tiered_rebate' && pnlReward.value && Array.isArray(pnlReward.value) && (
                  <div className="tiered-rebate-container">
                    {pnlReward.value.map((tier, index) => {
                      // Determine the loss range text
                      let lossRange = '';
                      if (index === 0) {
                        // First tier: 0 ≤ Loss < tier.loss
                        lossRange = `0 < -Loss ≤ ${tier.loss}`;
                      } else {
                        // Middle tier: previous.loss ≤ Loss < current.loss
                        lossRange = `${pnlReward.value[index - 1].loss} < -Loss ≤ ${tier.loss}`;
                      }
                      return (
                        <div key={index} className="tiered-rebate-card">
                          <div className="tiered-rebate-percentage">
                            <span className="reward-value-pnl">{tier.percentage ?? 0}%</span>
                          </div>
                          <div className="tiered-rebate-range">{lossRange}</div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}

            {programName === 'Net Deposit Sharing' && (
              <>
                {/* Percentage Reward Type */}
                {netDepositReward?.reward_type === 'percentage' &&
                  netDepositReward.value &&
                  Array.isArray(netDepositReward.value) && (
                    <div className="tiered-rebate-container">
                      {netDepositReward.value.map((tier, index) => {
                        // Determine the loss range text
                        let lossRange = '';
                        if (index === 0) {
                          // First tier: 0 ≤ Loss < tier.loss
                          lossRange = `0 < Net Deposit ≤ ${tier.deposit}`;
                        } else {
                          // Middle tier: previous.loss ≤ Loss < current.loss
                          lossRange = `${netDepositReward.value[index - 1].deposit} < Net Deposit ≤ ${tier.deposit}`;
                        }
                        return (
                          <div key={index} className="tiered-rebate-card">
                            <div className="tiered-rebate-percentage">
                              <span className="reward-value-pnl">{tier.percentage ?? 0}%</span>
                            </div>
                            <div className="tiered-rebate-range">{lossRange}</div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                {/* Tiered Rebate Reward Type */}
                {netDepositReward?.reward_type === 'fix' &&
                  netDepositReward.value &&
                  Array.isArray(netDepositReward.value) && (
                    <div className="tiered-rebate-container">
                      {netDepositReward.value.map((tier, index) => {
                        // Determine the loss range text
                        let lossRange = '';
                        if (index === 0) {
                          // First tier: 0 ≤ Loss < tier.loss
                          lossRange = `0 < Net Deposit ≤ ${tier.deposit}`;
                        } else {
                          // Middle tier: previous.loss ≤ Loss < current.loss
                          lossRange = `${netDepositReward.value[index - 1].deposit} < Net Deposit ≤ ${tier.deposit}`;
                        }
                        return (
                          <div key={index} className="tiered-rebate-card">
                            <div className="tiered-rebate-percentage">
                              <span className="reward-value-pnl">{tier.amount ?? 0}USD</span>
                            </div>
                            <div className="tiered-rebate-range">{lossRange}</div>
                          </div>
                        );
                      })}
                    </div>
                  )}
              </>
            )}
          </div>

          {/* Symbol Group Exceptions 区块 */}
          {groupExceptionsFormat &&
            typeof groupExceptionsFormat === 'object' &&
            Object.keys(groupExceptionsFormat).length > 0 && (
              <div className="section">
                <div className="section-header">
                  <h3 className="section-title">Symbol Group Exceptions</h3>
                  <button
                    type="button"
                    className={`arrow-icon ${expandedSections.symbolGroupExceptions ? 'expanded' : ''}`}
                    onClick={() => toggleSection('symbolGroupExceptions')}
                    style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
                    aria-expanded={expandedSections.symbolGroupExceptions}
                    aria-label={expandedSections.symbolGroupExceptions ? '收起区块' : '展开区块'}>
                    ›
                  </button>
                </div>

                {/* 符号组异常表格 */}
                {expandedSections.symbolGroupExceptions && (
                  <div className="exceptions-table">
                    <div className="table-header">
                      <span className="table-header-cell">Name</span>
                      <span className="table-header-cell">Reward</span>
                      <span className="table-header-cell">Reward Type</span>
                    </div>
                    {/* 处理嵌套的groupExceptions结构 */}
                    {(() => {
                      // 检查是否是新的数据结构
                      if (groupExceptionsFormat && Array.isArray(groupExceptionsFormat.group_reward_items)) {
                        // 对于fix类型的奖励，先按name聚合数据
                        const groupedItems = [];
                        groupExceptionsFormat.group_reward_items.forEach(item => {
                          if (item.reward_type === 'fix') {
                            const existing = groupedItems.find(
                              g => g.group_name === item.group_name && g.reward_type === 'fix'
                            );
                            if (existing) {
                              existing.rewards.push(...(item.rewards || []));
                            } else {
                              groupedItems.push({ ...item, rewards: [...(item.rewards || [])] });
                            }
                          } else {
                            groupedItems.push(item);
                          }
                        });

                        // 创建一个空数组来存储所有的表格行
                        const tableRows = [];

                        // 遍历聚合后的每一项
                        groupedItems.forEach((groupRewardItem, groupIndex) => {
                          // 检查是否有rewards数组
                          if (groupRewardItem.rewards && Array.isArray(groupRewardItem.rewards)) {
                            if (groupRewardItem.reward_type === 'fix') {
                              // 对于fix，将相同name的所有rewards放在同一行展示
                              tableRows.push(
                                <div key={groupIndex} className="table-row">
                                  <div className="table-cell">{groupRewardItem.group_name}</div>
                                  <div
                                    className="table-cell"
                                    style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    {groupRewardItem.rewards.map((reward, rewardIndex) => (
                                      <div key={rewardIndex} className="reward-condition">
                                        <div className="reward-value-1">
                                          {reward.amount || 0}
                                          {groupRewardItem.reward_type === 'fix' ? 'USD' : '%'}
                                        </div>
                                        <div className="reward-condition-text">{reward.content || ''}</div>
                                      </div>
                                    ))}
                                  </div>
                                  <div className="table-cell">{mapRewardTypeToText(groupRewardItem.reward_type)}</div>
                                </div>
                              );
                            } else {
                              // 遍历每个reward，保持原来的逻辑（独占一行）
                              groupRewardItem.rewards.forEach((reward, rewardIndex) => {
                                // 生成唯一的key
                                const key = `${groupIndex}-${rewardIndex}`;

                                // 将每一行添加到结果数组
                                tableRows.push(
                                  <div key={key} className="table-row">
                                    <div className="table-cell">{groupRewardItem.group_name}</div>
                                    <div className="table-cell">
                                      <div className="reward-condition">
                                        <div className="reward-value-1">
                                          {reward.amount || 0}
                                          {groupRewardItem.reward_type === 'fix' ? 'USD' : '%'}
                                        </div>
                                        <div className="reward-condition-text">{reward.content || ''}</div>
                                      </div>
                                    </div>
                                    <div className="table-cell">{mapRewardTypeToText(groupRewardItem.reward_type)}</div>
                                  </div>
                                );
                              });
                            }
                          }
                        });

                        return tableRows;
                      }
                      // 如果条件不满足，返回空数组
                      return [];
                    })()}
                  </div>
                )}
              </div>
            )}

          {/* Symbol Exceptions 区块 */}
          {symbolExceptionsFormat &&
            typeof symbolExceptionsFormat === 'object' &&
            Object.keys(symbolExceptionsFormat).length > 0 && (
              <div className="section">
                <div className="section-header">
                  <h3 className="section-title">Symbol Exceptions</h3>
                  <button
                    type="button"
                    className={`arrow-icon ${expandedSections.symbolExceptions ? 'expanded' : ''}`}
                    onClick={() => toggleSection('symbolExceptions')}
                    style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
                    aria-expanded={expandedSections.symbolExceptions}
                    aria-label={expandedSections.symbolExceptions ? '收起区块' : '展开区块'}>
                    ›
                  </button>
                </div>

                {/* 符号异常表格 */}
                {expandedSections.symbolExceptions && (
                  <div className="exceptions-table">
                    <div className="table-header">
                      <span className="table-header-cell">Name</span>
                      <span className="table-header-cell">Reward</span>
                      <span className="table-header-cell">Reward Type</span>
                    </div>
                    {/* 处理嵌套的symbolExceptions结构 */}
                    {(() => {
                      // 检查是否是新的数据结构
                      if (symbolExceptionsFormat && Array.isArray(symbolExceptionsFormat.group_reward_items)) {
                        // 对于fix类型的奖励，先按name聚合数据
                        const groupedItems = [];
                        symbolExceptionsFormat.group_reward_items.forEach(item => {
                          if (item.reward_type === 'fix') {
                            const existing = groupedItems.find(
                              g => g.group_name === item.group_name && g.reward_type === 'fix'
                            );
                            if (existing) {
                              existing.rewards.push(...(item.rewards || []));
                            } else {
                              groupedItems.push({ ...item, rewards: [...(item.rewards || [])] });
                            }
                          } else {
                            groupedItems.push(item);
                          }
                        });

                        // 创建一个空数组来存储所有的表格行
                        const tableRows = [];

                        // 遍历聚合后的每一项
                        groupedItems.forEach((groupRewardItem, groupIndex) => {
                          // 检查是否有rewards数组
                          if (groupRewardItem.rewards && Array.isArray(groupRewardItem.rewards)) {
                            if (groupRewardItem.reward_type === 'fix') {
                              // 对于fix，将相同name的所有rewards放在同一行展示
                              tableRows.push(
                                <div key={groupIndex} className="table-row">
                                  <div className="table-cell">{groupRewardItem.group_name}</div>
                                  <div
                                    className="table-cell"
                                    style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    {groupRewardItem.rewards.map((reward, rewardIndex) => (
                                      <div key={rewardIndex} className="reward-condition">
                                        <div className="reward-value-1">
                                          {reward.amount || 0}
                                          {groupRewardItem.reward_type === 'fix' ? 'USD' : '%'}
                                        </div>
                                        <div className="reward-condition-text">{reward.content || ''}</div>
                                      </div>
                                    ))}
                                  </div>
                                  <div className="table-cell">{mapRewardTypeToText(groupRewardItem.reward_type)}</div>
                                </div>
                              );
                            } else {
                              // 遍历每个reward，保持原来的逻辑（独占一行）
                              groupRewardItem.rewards.forEach((reward, rewardIndex) => {
                                // 生成唯一的key
                                const key = `${groupIndex}-${rewardIndex}`;

                                // 将每一行添加到结果数组
                                tableRows.push(
                                  <div key={key} className="table-row">
                                    <div className="table-cell">{groupRewardItem.group_name}</div>
                                    <div className="table-cell">
                                      <div className="reward-condition">
                                        <div className="reward-value-1">
                                          {reward.amount || 0}
                                          {groupRewardItem.reward_type === 'fix' ? 'USD' : '%'}
                                        </div>
                                        <div className="reward-condition-text">{reward.content || ''}</div>
                                      </div>
                                    </div>
                                    <div className="table-cell">{mapRewardTypeToText(groupRewardItem.reward_type)}</div>
                                  </div>
                                );
                              });
                            }
                          }
                        });

                        return tableRows;
                      }
                      // 如果条件不满足，返回空数组
                      return [];
                    })()}
                  </div>
                )}
              </div>
            )}

          {/* Sub IB 部分 - 保留原有的功能但调整样式 */}
          {subIbEnabled && Array.isArray(subIbSettings) && subIbSettings.length > 0 && (
            <div className="section">
              <div className="section-header">
                <h3 className="section-title">Sub IB Settings</h3>
              </div>
              <div className="subib-settings">
                {subIbSettings.map((item, index) => (
                  // <div key={index} className="subib-item">
                  //   <span className="subib-level">Level {index + 1}</span>
                  //   <span className="subib-value">{item || 0}%</span>
                  // </div>
                  <div key={index} className="rewards-card-pnl">
                    <div className="rewards-body-pnl">
                      <span className="reward-value-pnl">{item || 0}%</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

CurrentIBProgramsItem.propTypes = {
  conditions: PropTypes.object,
  theme: PropTypes.object,
};

CurrentIBProgramsItem.defaultProps = {
  conditions: {},
  theme: {},
};

export default withTheme()(CurrentIBProgramsItem);
export { CurrentIBProgramsItem };
